<template>
    <div>
      <div class="weui-tabbar weui-footer_fixed-bottom bottom">
        <router-link to="/Home" class="weui-tabbar__item" v-bind:class="tabbarSelected == 0 ? 'weui-bar__item_on':''" >
          <div @click="tabOnClick(0)">
            <img class="bar-icon home" v-bind:src="tabbarSelected == 0 ? icons[0][1] : icons[0][0]">
            <p class="weui-tabbar__label" >首页</p>
          </div>
        </router-link>
        <router-link to="/Form" class="weui-tabbar__item" v-bind:class="tabbarSelected==1?'weui-bar__item_on':''">
          <div @click="tabOnClick(1)">
            <img class="bar-icon form" v-bind:src="tabbarSelected == 1 ? icons[1][1] : icons[1][0]">
            <p class="weui-tabbar__label">退税单</p>
          </div>
        </router-link>
        <router-link to="/Me" class="weui-tabbar__item" v-bind:class="tabbarSelected==2?'weui-bar__item_on':''">
          <div @click="tabOnClick(2)">
            <img class="bar-icon me" v-bind:src="tabbarSelected == 2 ? icons[2][1] : icons[2][0]">
            <p class="weui-tabbar__label">我</p>
          </div>
        </router-link>
      </div>
    </div>
</template>
<style lang="stylus">
  @import '~weui/dist/style/weui.min.css';
  @import '../style/base.css'
  .bar-icon
    width 25px
    height 25px
  .bottom
    bottom: 0
  .page
    position absolute
    bottom 51px
    left 0
    right 0
    top 0
    background-color #fafafa
</style>
<script>
  export default{
    data () {
      return {
        icons: [
          [
            require('../assets/home_inactive.png'),
            require('../assets/home_active.png')
          ],
          [
            require('../assets/form_inactive.png'),
            require('../assets/form_active.png')
          ],
          [
            require('../assets/user_inactive.png'),
            require('../assets/user_active.png')
          ]
        ],
        tab: [
          require('../assets/home_active.png'),
          require('../assets/form_inactive.png'),
          require('../assets/user_inactive.png')
        ]
      }
    },

    computed: {
      tabbarSelected () {
        return this.$store.getters.getTabbarSelected
      }
    },

    methods: {
      tabOnClick (index) {
        this.$store.commit('setTabbarSelected', index)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TabBar.vue?6097a5b4